<div class="main-container">
  <div class="main-content">
    <div class="search-container">
      <svg *ngIf="doSVG === true" width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="45" cy="45" r="45" fill="white" />
        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="90" height="90">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.000488281 0H90V90H0.000488281V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45.0005 0C20.1465 0 0.000488281 20.147 0.000488281 45C0.000488281 69.853 20.1465 90 45.0005 90C69.8535 90 90.0005 69.853 90.0005 45C90.0005 20.147 69.8535 0 45.0005 0ZM45.0005 2C68.7105 2 88.0005 21.29 88.0005 45C88.0005 68.71 68.7105 88 45.0005 88C21.2895 88 2.00049 68.71 2.00049 45C2.00049 21.29 21.2895 2 45.0005 2Z"
            fill="var(--dhcl-color-gray-light-medium)"
          />
          <mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="23" y="52" width="44" height="15">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.8618 59.554C23.8618 64.09 33.2958 67 45.0008 67C56.7038 67 66.1378 64.09 66.1378 59.554C66.1378 56.278 61.2098 53.86 54.0708 52.762C53.4518 53.617 52.8228 54.436 52.1988 55.217C58.8118 56.042 63.4728 57.896 63.4728 59.554C63.4728 61.767 55.1698 64.327 45.0008 64.327C34.8298 64.327 26.5268 61.767 26.5268 59.554C26.5268 57.889 31.2298 56.029 37.8898 55.208C37.2638 54.424 36.6348 53.603 36.0138 52.749C28.8308 53.839 23.8618 56.266 23.8618 59.554Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.6592 75.2029H74.3422V44.5449H15.6592V75.2029Z"
              fill="var(--dhcl-color-primary)"
            />
          </g>
          <mask id="mask2" mask-type="alpha" maskUnits="userSpaceOnUse" x="31" y="23" width="28" height="38">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M44.366 23C37.98 23 31.377 28.532 31.377 37.791C31.377 45.727 40.372 55.858 44.24 59.845C44.67 60.281 45.428 60.281 45.853 59.842C49.723 55.857 58.72 45.731 58.72 37.791C58.72 28.532 52.115 23 45.729 23H44.366ZM43.574 41.916C41.428 41.196 40.189 39.077 40.631 36.882C40.973 35.195 42.422 33.793 44.158 33.471C45.849 33.16 47.463 33.747 48.51 34.969C49.391 35.999 49.729 37.301 49.465 38.64C49.182 40.097 48.059 41.376 46.605 41.897C46.386 41.976 46.16 42.04 45.921 42.083C45.635 42.137 45.343 42.162 45.061 42.162C44.555 42.162 44.056 42.08 43.574 41.916Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.1729 68.3749H66.9219V14.7969H23.1729V68.3749Z"
              fill="var(--dhcl-color-primary)"
            />
          </g>
        </g>
      </svg>

      <h1 class="h1">
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.959 9.38007C15.9598 12.3499 18.2683 14.7568 21.1156 14.7568C23.9632 14.7514 26.2696 12.3435 26.2722 9.37343C26.2696 6.40368 23.9598 3.99816 21.1124 4C18.2651 4.00185 15.9581 6.41031 15.959 9.38007ZM17.833 7.95828C18.3839 6.57506 19.6796 5.6744 21.1156 5.67639V5.6714C22.057 5.67275 22.9593 6.06401 23.624 6.75921C24.2887 7.45441 24.6614 8.39658 24.6602 9.37842C24.6602 10.8762 23.7949 12.2264 22.468 12.7991C21.1411 13.3718 19.6141 13.0542 18.5993 11.9944C17.5846 10.9346 17.2822 9.34145 17.833 7.95828Z"
            fill="var(--dhcl-color-primary)"
          />
          <path
            d="M22.6151 10.1716H19.1566C18.7115 10.1716 18.3506 9.79523 18.3506 9.33093C18.3506 8.86662 18.7115 8.49023 19.1566 8.49023H22.6151C23.0602 8.49023 23.4211 8.86662 23.4211 9.33093C23.4211 9.79523 23.0602 10.1716 22.6151 10.1716Z"
            fill="var(--dhcl-color-primary)"
          />
          <path
            d="M21.0678 11.8102C20.624 11.8102 20.2642 11.4349 20.2642 10.972V7.33483C20.2642 6.87053 20.625 6.49414 21.0702 6.49414C21.5153 6.49414 21.8762 6.87053 21.8762 7.33483V10.967C21.8775 11.191 21.7927 11.4063 21.6409 11.5647C21.4889 11.7231 21.2826 11.8115 21.0678 11.8102Z"
            fill="var(--dhcl-color-primary)"
          />
          <path
            d="M36.828 37.9085H4.77847C4.33934 37.8739 4 37.4922 4 37.0328C4 36.5735 4.33934 36.1918 4.77847 36.1572H36.828C37.2672 36.1918 37.6065 36.5735 37.6065 37.0328C37.6065 37.4922 37.2672 37.8739 36.828 37.9085Z"
            fill="#7F736C"
          />
          <path
            d="M18.9879 36.3869V29.4419C18.9824 29.2022 19.1603 29.0013 19.3898 28.9879H22.8148C23.0442 29.0013 23.2221 29.2022 23.2166 29.4419V36.3869H24.8286V29.4419C24.869 28.2376 23.9692 27.2255 22.8148 27.1768H19.4089C18.2526 27.2254 17.3519 28.2407 17.395 29.4469V36.3869H18.9879Z"
            fill="#7F736C"
          />
          <path
            d="M25.2963 23.8489H17.1069C16.7197 23.7787 16.437 23.4281 16.437 23.0182C16.437 22.6083 16.7197 22.2577 17.1069 22.1875H25.2867C25.7078 22.2214 26.033 22.5876 26.033 23.0282C26.033 23.4687 25.7078 23.835 25.2867 23.8689L25.2963 23.8489Z"
            fill="#7F736C"
          />
          <path
            d="M25.2963 20.264H17.1069C16.7197 20.1937 16.437 19.8432 16.437 19.4333C16.437 19.0233 16.7197 18.6728 17.1069 18.6025H25.2867C25.7078 18.6364 26.033 19.0027 26.033 19.4432C26.033 19.8838 25.7078 20.25 25.2867 20.2839L25.2963 20.264Z"
            fill="#7F736C"
          />
          <path
            d="M7.52513 37.4556H5.91309V27.8712C5.91309 26.4543 6.30055 25.3766 7.06591 24.6133C7.72757 23.9896 8.59492 23.6571 9.48637 23.6853H12.9018V25.3666H9.40984C8.94804 25.3698 8.50288 25.5469 8.15655 25.8656C7.697 26.4147 7.47084 27.135 7.52991 27.8613L7.52513 37.4556Z"
            fill="#7F736C"
          />
          <path
            d="M36.3126 37.4506H34.7244V27.8662C34.7907 27.1283 34.5603 26.3947 34.0882 25.8406C33.7443 25.5242 33.303 25.3472 32.8445 25.3417H29.3525V23.6853H32.768C33.6594 23.6571 34.5268 23.9896 35.1884 24.6133C35.9538 25.3567 36.3413 26.4493 36.3413 27.8712L36.3126 37.4506Z"
            fill="#7F736C"
          />
          <path
            d="M27.2812 7.99135H27.1425C27.2038 8.3437 27.2358 8.70093 27.2382 9.05906C27.2382 9.26361 27.2382 9.46817 27.2095 9.67273H27.2812C28.0965 9.65303 28.776 10.3195 28.8072 11.1695V35.9924L13.7439 35.9325V11.1945C13.775 10.3445 14.4545 9.67797 15.2698 9.69768H15.3416C15.3416 9.49811 15.3129 9.29355 15.3129 9.084C15.3152 8.72587 15.3472 8.36864 15.4085 8.0163H15.265C13.5541 7.99964 12.1528 9.42996 12.1318 11.2144V37.6089L30.4144 37.6787V11.1945C30.396 9.40805 28.994 7.97474 27.2812 7.99135Z"
            fill="#7F736C"
          />
          <path
            d="M34.9898 29.3572H29.68C29.2349 29.3572 28.874 28.9808 28.874 28.5165C28.874 28.0522 29.2349 27.6758 29.68 27.6758H34.9898C35.4349 27.6758 35.7958 28.0522 35.7958 28.5165C35.7958 28.9808 35.4349 29.3572 34.9898 29.3572Z"
            fill="#7F736C"
          />
          <path
            d="M12.5073 29.3572H7.19762C6.75247 29.3572 6.3916 28.9808 6.3916 28.5165C6.3916 28.0522 6.75247 27.6758 7.19762 27.6758H12.5073C12.9525 27.6758 13.3133 28.0522 13.3133 28.5165C13.3133 28.9808 12.9525 29.3572 12.5073 29.3572Z"
            fill="#7F736C"
          />
        </svg>

        Find a Virginia Mason Franciscan Health location
      </h1>
      <div class="search-box">
        <fal-combined-search-box [showLandingFilters]="true"></fal-combined-search-box>
      </div>
    </div>
  </div>
  <div class="line-container">
    <div class="line"></div>
  </div>
  <div class="subheading" *ngIf="emergencyText">
    <span class="subheading_text p"><a href="tel: 911">{{emergencyText}}</a></span>
  </div>
  <div class="subheading">
    <span class="subheading_text p">{{searchHomeDescription}}</span>
  </div>
</div>
<div *ngIf="showERInfo" class="info-container">
  <h3>For non-life-threatening emergencies, visit one of our <a href="#">ER or urgent care centers</a> near you.</h3>
</div>
<div class="footer-container">
  <fal-shared-footer></fal-shared-footer>
</div>
